import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { outcomesApi: OutcomesApi }): DialogConfig {
  const { outcomesApi } = options;

  return {
    id: "delete-outcome",
    title: "Delete outcome",
    description: "Are you sure you want to delete this outcome?",
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: { type: "flat", children: [] },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await outcomesApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" outcome.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" outcome.`);
        }
      },
    },
  };
}
